module.exports = __webpack_public_path__ + "img/uche.994a9b0c.jpg";